import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconVideo"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.5C2 5.11929 3.11929 4 4.5 4H13.5C14.8807 4 16 5.11929 16 6.5V9.19109L19.8292 7.27651C20.8265 6.77783 22 7.50307 22 8.61815V15.3821C22 16.4972 20.8265 17.2224 19.8292 16.7237L16 14.8091V17.5C16 18.8807 14.8807 20 13.5 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5ZM16 13.6911L20.2764 15.8293C20.6088 15.9955 21 15.7538 21 15.3821V8.61815C21 8.24646 20.6088 8.00471 20.2764 8.17093L16 10.3091V13.6911Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideo;
